import React, { useState, useEffect } from 'react';
import { Alert, Button, Modal, Select, message } from 'antd';
import axios from 'axios';
import { DropDownApi, EnterByTask, getWorkOrderTable } from '../../../Services/LocomotiveServices';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { TableWoDelete } from '../../../Services/employee';
import EnterByTaskModal from './EnterByTaskModal';
import { Message } from '@material-ui/icons';
import { errorMessage } from '../../../helpers';
const AcceptModal = ({ visible, onOk, onCancel, selectedCauseCode, setSelectedCauseCode, setAllSelectedCauseCodes }) => {
  const [options, setOptions] = useState([]);
  const [DataRecord, setDataRecord] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedValues, setSelectedValues] = useState({});

  const [optionSelected, setOptionSelected] = useState([]);
  const [isSelectDisabled, setIsSelectDisabled] = useState(false);

  const history = useHistory()
  const { location } = history
  const id = location?.state?.id;


  const [errorMessage, setErrorMessage] = useState('');



  const handleOk = async () => {

    const payload = {
      tasks: DataRecord?.map((task, index) => ({
        id: task?.id,
        CauseCode: selectedValues[index] !== undefined ? selectedValues[index] : 'DEFAULT_CAUSE_CODE'
      }))
    };

    const checkIfDefaultCauseCode = payload.tasks?.filter(x => x?.CauseCode === "DEFAULT_CAUSE_CODE")
    if (checkIfDefaultCauseCode?.length) return message.error("Kindly enter cause code for all tasks.")

    try {

      const response = await EnterByTask(id, payload);
      setAllSelectedCauseCodes(payload?.tasks?.map(x => x?.CauseCode))
      setIsSelectDisabled(true);

      setIsModalOpen(false);

    } catch (error) {
      console.error('Error in component:', error);
    }
  };


  const handleCancel = () => {
    setIsModalOpen(false);
  };



  const fetchData = async () => {
    try {
      const response = await DropDownApi();
      setOptions(response?.data);

    } catch (error) {
      console.error('Error in component:', error);
    }
  };


  const ShowDeleteTable = async () => {
    try {
      setIsModalOpen(true);
      const response = await getWorkOrderTable(id);
      setDataRecord(response?.data);



    } catch (error) {
      console.error('Error fetching data from API:', error);
    }
  };



  useEffect(() => {
    if (visible) {
      fetchData();
    }
  }, [visible]);

  return (
    <Modal
      title={<span style={{ color: '#2963ad', fontSize: '20px', fontWeight: '800', background: 'white' }}>WO Closeout Code</span>}
      visible={visible}
      footer={null}
      okText="Confirm"
      okButtonProps={{ style: { background: '#2963ad' } }}
      onCancel={onCancel}
    >
      <h3 style={{ fontWeight: 'bold' }}>Closeout Code</h3>
      <Select
        style={{ width: '100%' }}
        value={selectedCauseCode}
        onChange={(value) => setSelectedCauseCode(value)}
        disabled={isSelectDisabled}

      >
        {options && options?.length > 0 ? (
          options?.map(option => (
            <Select.Option key={option.id} value={option.CauseCode}>
              {option?.CauseName}
            </Select.Option>
          ))
        ) : (
          <Select.Option value={undefined} disabled>
            Select any option
          </Select.Option>
        )}
      </Select>
      <div style={{ marginTop: '10px' }}>
        <Button style={{ background: '#2963ad', color: 'white', marginRight: '5px' }} onClick={ShowDeleteTable}>Enter By Task</Button>
        <Button style={{ background: '#2963ad', color: 'white' }} onClick={() => onOk(selectedCauseCode)}>Confirm</Button>

      </div>
      <EnterByTaskModal showModal={isModalOpen} handleCancel={handleCancel} handleOk={handleOk} setData={DataRecord} optionSelected={selectedCauseCode} setOptionSelected={setSelectedCauseCode} selectedValues={selectedValues} setSelectedValues={setSelectedValues} />
    </Modal>
  );
};

export default AcceptModal;